var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6bb27e87633116c5fe28fd41f8c6fa1f.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8da6b4d13c21f999b63775891745b1ae.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c30b66323757154f6a1b23bf15bddb7d.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    